import * as yup from 'yup'
import { Button, CenteredFormCard, Column, Grid, Row, TextField } from '../../../base'
import { FieldPath } from 'react-hook-form/dist/types/path'
import { ForgotPasswordRequestData, useForgotPassword } from '../../../../auth/auth'
import { handleFormErrorsFromAxios } from '../../../../utils/Helper'
import { useForm } from 'react-hook-form'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { yupResolver } from '@hookform/resolvers/yup'
import ArrowLeftIcon from '../../../../assets/img/arrow-left-icon.svg'
import ForgottenPasswordIllustration from '../../../../assets/img/forgot_password_illustration.svg'
import NextLink from 'next/link'
import React from 'react'
import validator from 'validator'

const ForgottenPasswordSendEmailCard = () => {
    const { t } = useTranslation('forgottenPassword')
    const { push } = useRouter()
    const { forgotPassword, isLoading } = useForgotPassword<ForgotPasswordRequestData>()

    const {
        handleSubmit,
        register,
        formState: { errors },
        setError
    } = useForm<ForgotPasswordRequestData>({
        resolver: yupResolver(
            yup.object({
                email: yup.string()
                    .test('is-email',
                        t('forgottenPasswordPage.form.email.validation.notValid'),
                        value => {
                            return validator.isEmail(value || '')
                        }
                    )
                    .required(t('forgottenPasswordPage.form.email.validation.required'))
            })
        ),
        reValidateMode: 'onChange'
    })

    const getFieldError = (path: FieldPath<ForgotPasswordRequestData>) => {
        return errors[path]?.message
    }

    const submit = (data: ForgotPasswordRequestData) => {
        return forgotPassword(data)
            .then(() => {
                return push('/forgotten-password/sent-email')
            })
            .catch((error) => {
                return handleFormErrorsFromAxios(error, setError)
            })
    }

    const renderTitle = () => {
        return (
            <h1 tw='text-h2 text-primary-400'>{t('forgottenPasswordPage.title')}</h1>
        )
    }

    const renderHeader = () => {
        return (
            <ForgottenPasswordIllustration/>
        )
    }

    const renderDescription = () => {
        return (
            <p tw='text-normal font-normal text-primary-400'>
                {t('forgottenPasswordPage.description')}
            </p>
        )
    }

    const renderFooter = () => {
        return (
            <NextLink href='/' passHref>
                <Button as='a' variant='text' underlineText leftIcon={<ArrowLeftIcon/>}>
                    {t('forgottenPasswordPage.backToLoginButtonLabel')}
                </Button>
            </NextLink>
        )
    }

    return (
        <CenteredFormCard
            onSubmit={handleSubmit(submit)}
            submitLabel={t('forgottenPasswordPage.form.submit')}
            title={renderTitle()}
            header={renderHeader()}
            footer={renderFooter()}
            description={renderDescription()}
            loading={isLoading}
        >
            <Grid>
                <Row>
                    <Column cols={12}>
                        <TextField 
                            label={t('forgottenPasswordPage.form.email.label')}
                            type='email'
                            invalidMessage={getFieldError('email')}
                            {...register('email')}
                        />
                    </Column>
                </Row>
            </Grid>
        </CenteredFormCard>
    )
}

export default ForgottenPasswordSendEmailCard
